import * as ActionTypes from 'state/actions/types'

export const handoffChangeField = (field, value) => {
  return {
    type: ActionTypes.HANDOFF_CHANGE_FIELD,
    field,
    value
  }
}

export const handoffChangeDateRange = (startDate, endDate) => {
  return {
    type: ActionTypes.HANDOFF_CHANGE_CUSTOM_DATE_RANGE,
    startDate,
    endDate
  }
}

export const handoffMoveCustomDateRange = operation => {
  return {
    type: ActionTypes.HANDOFF_MOVE_CUSTOM_DATE_RANGE,
    operation
  }
}
